export enum CASE_ACTION {
  SELECT_RETAINER = "select_retainer",
  SELECT_UASSIST = "select_uassist",
  SELECT_SELFPLAN = "select_self",
  START_PRESETUP = "start_presetup",
  REUPLAD_SCANS = "reupload_scans",
  REUPLOAD_SCANS_FOR_SELF_REFINEMENT = "reupload_scans_for_self_refinement",
  FAIL_PRESETUP = "fail_presetup",
  COMPLETE_PRESETUP = "complete_presetup",
  START_REFINE_PRESETUP = "start_self_refinement_presetup",
  PRESETUP_RETRY_WITH_UASSIST = "presetup_retry_with_uassist",
}